import { ProgramCreate } from './ProgramCreate';
import { ProgramEdit } from './ProgramEdit';
import { ProgramList } from './ProgramList';

export default {
    create: ProgramCreate,
    edit: ProgramEdit,
    list: ProgramList
}
